import { createSelector } from "reselect";
import "./endpoints/index.js";
import { getOperationSetStepIds } from "../../../models/expapiunified/ExperimentOperationSet.model.js";
import { selectAllExperimentOperationSets } from "./endpoints/experiment-operation-sets.js";
import { selectAllExperiments, selectExperimentById } from "./endpoints/experiments.js";
import { selectAllAudienceFilters } from "./endpoints/audience-filters.js";
const selectExperimentOperationSetsByFeatureId = (state, featureId) => selectAllExperimentOperationSets(state).filter((s) => s.featureId === featureId);
const selectExperimentOperationSetsByProgressionId = createSelector(
  [
    selectExperimentOperationSetsByFeatureId,
    (state, featureId, progressionId) => selectAllExperiments(state).filter((e) => e.progressionId === progressionId)
  ],
  (sets, experiments) => {
    const stepIds = experiments.flatMap((e) => e.experimentSteps).map((s) => s.id);
    return sets.filter((set) => getOperationSetStepIds(set).some((id) => stepIds.includes(id)));
  }
);
const selectExperimentOperationSetsByExperimentId = createSelector(
  [
    selectExperimentOperationSetsByFeatureId,
    (state, featureId, experimentId) => selectExperimentById(state, experimentId)
  ],
  (sets, experiment) => {
    if (!experiment) {
      return [];
    }
    const stepIds = experiment.experimentSteps.map((s) => s.id);
    return sets.filter((set) => getOperationSetStepIds(set).some((id) => stepIds.includes(id)));
  }
);
const selectAudienceFiltersByExperimentationGroup = (state, workspaceId, experimentationGroup) => selectAllAudienceFilters(state).filter(
  (f) => !f.experimentationGroups.length || f.experimentationGroups.includes(experimentationGroup)
);
const filterAudienceFiltersByExperimentationGroup = (audienceFilters, experimentationGroup) => experimentationGroup ? audienceFilters.filter((f) => !f.experimentationGroups.length || f.experimentationGroups.includes(experimentationGroup)) : audienceFilters;
export {
  filterAudienceFiltersByExperimentationGroup,
  selectAudienceFiltersByExperimentationGroup,
  selectExperimentOperationSetsByExperimentId,
  selectExperimentOperationSetsByFeatureId,
  selectExperimentOperationSetsByProgressionId
};
//# sourceMappingURL=selectors.js.map
